<template>
<div id="contents">

  <div id="recruit_2025_teaser">
    <div id="recruit_2025_teaser_contents" class="js-shadow">
      <div id="header">
        <p class="ttl"><router-link v-bind:to="{name: 'index', params : { link: true } }"><img src="../assets/img/recruit/2025/teaser/logo.png" width="306" alt="テレビ朝日映像"/></router-link></p>
        <div class="link_list">
          <p class="sns"><a href="https://www.instagram.com/tv_asahipro_saiyo/" target="_blank" rel="noopener"><img src="../assets/img/recruit/2025/teaser/instagram_icon.png" width="48" alt="Instagram"/></a></p>
          <p class="link_btn entry"><a href="https://job.mynavi.jp/26/pc/search/corp93057/is.html" target="_blank" rel="noopener"><img src="../assets/img/recruit/2025/top/header_link_entry.svg" width="76" alt="ENTRY"/></a></p>
          <p class="link_btn"><router-link v-bind:to="{name: 'recruit_2025_application', params : { link: true } }"><img src="../assets/img/recruit/2025/top/header_link_application.svg" width="93" alt="応募要項"/></router-link></p>
        </div>
      </div><!-- #header -->
      <div id="kv">
        <h1 class="js-kv_ttl ttl"><img src="../assets/img/recruit/2025/teaser/kv_title.png" width="650" alt="その熱量で映像業界を駆け上がれ。RECRUIT 2025"/></h1>
        <p class="js-kv_message message"><img src="../assets/img/recruit/2025/teaser/kv_message.png" width="651" alt="この業界には、正解がない。だからこそ、あなたが見て、聞いて、触れて、考えたすべてから生まれてくるむきだしの”最適解”こそが何よりの武器になる。映像が好きだという気持ちと、好奇心と、意地と、プライドを抱えて。映像業界で駆け上がれ。"/></p>
      </div><!-- #kv -->
      <div id="content">
        <div id="content_inner">
          <p class="ttl"><img src="../assets/img/recruit/2025/teaser/contents_ttl.png" width="282" alt="コンテンツ"/></p>
          <p class="coming_soon"><img src="../assets/img/recruit/2025/teaser/content_coming_soon.png" width="303" alt="COMING SOON"/></p>
        </div>
      </div><!-- #content -->
      <div id="recruit_2024">
        <div id="recruit_2024_inner">
          <p class="ttl"><img src="../assets/img/recruit/2025/teaser/recruit_2024_ttl.png" width="456" alt="RECRUIT 2024 はこちら！"/></p>
          <p class="btn"><router-link v-bind:to="{name: 'recruit_2024', params : { link: true } }" target="_blank"><img src="../assets/img/recruit/2025/teaser/recruit_2024_btn_ttl.png" width="521" alt="RECRUIT 2024"/></router-link></p>
        </div>
      </div><!-- #recruit -->
      <div id="contact">
        <div id="contact_inner">
          <p class="btn"><router-link v-bind:to="{name: 'contact', params : { link: true } }" target="_blank"><img src="../assets/img/recruit/2025/teaser/contact_btn_ttl.png" width="240" alt="CONTACT"/></router-link></p>
          <p class="logo"><img src="../assets/img/recruit/2025/teaser/logo.png" width="297" alt="テレビ朝日映像"/></p>
        </div>
      </div><!-- #contact -->
      <!-- <div id="js-load"></div> -->
      <div id="video">
        <div id="video_inner">
          <video autoplay muted playsinline webkit-playsinline loop>
            <source src="../assets/img/recruit/2025/teaser/bg.mp4" type="video/mp4">
          </video>
        </div>
      </div>
      <p class="js-kv_deco kv_deco kv_deco_01 active"><img src="../assets/img/recruit/2025/teaser/kv_deco_01.png" width="1837" alt=""/></p>
      <p class="js-kv_deco kv_deco kv_deco_02"><img src="../assets/img/recruit/2025/teaser/kv_deco_02.png" width="1775" alt=""/></p>
      <p class="js-kv_deco kv_deco kv_deco_03"><img src="../assets/img/recruit/2025/teaser/kv_deco_03.png" width="1580" alt=""/></p>
      <ul class="new_kv_deco">
        <li class="js-deco deco_01"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_02"><img src="../assets/img/recruit/2025/teaser/deco/green_01_514.png" width="514" alt="" /></li>
        <li class="js-deco deco_03"><img src="../assets/img/recruit/2025/teaser/deco/red_01_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_04"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_05"><img src="../assets/img/recruit/2025/teaser/deco/red_01_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_06"><img src="../assets/img/recruit/2025/teaser/deco/blue_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_07"><img src="../assets/img/recruit/2025/teaser/deco/red_04_405.png" width="405" alt="" /></li>
        <li class="js-deco deco_08"><img src="../assets/img/recruit/2025/teaser/deco/blue_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_09"><img src="../assets/img/recruit/2025/teaser/deco/green_02_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_10"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_11"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_12"><img src="../assets/img/recruit/2025/teaser/deco/red_03_514.png" width="514" alt="" /></li>
        <li class="js-deco deco_13"><img src="../assets/img/recruit/2025/teaser/deco/red_01_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_14"><img src="../assets/img/recruit/2025/teaser/deco/red_01_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_15"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_16"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_17"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_18"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_19"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_20"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_21"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_22"><img src="../assets/img/recruit/2025/teaser/deco/blue_03_514.png" width="514" alt="" /></li>
        <li class="js-deco deco_23"><img src="../assets/img/recruit/2025/teaser/deco/red_04_405.png" width="405" alt="" /></li>
        <li class="js-deco deco_24"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_25"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_26"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_27"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_28"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_29"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="" alt="" /></li>
        <li class="js-deco deco_30"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_31"><img src="../assets/img/recruit/2025/teaser/deco/green_04_342.png" width="342" alt="" /></li>
        <li class="js-deco deco_32"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_33"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_34"><img src="../assets/img/recruit/2025/teaser/deco/blue_04_370.png" width="370" alt="" /></li>
        <li class="js-deco deco_35"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_36"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_37"><img src="../assets/img/recruit/2025/teaser/deco/red_03_514.png" width="514" alt="" /></li>
        <li class="js-deco deco_38"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
        <li class="js-deco deco_39"><img src="../assets/img/recruit/2025/teaser/deco/red_03_514.png" width="514" alt="" /></li>
        <li class="js-deco deco_40"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_41"><img src="../assets/img/recruit/2025/teaser/deco/blue_01_471.png" width="471" alt="" /></li>
        <li class="js-deco deco_42"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_43"><img src="../assets/img/recruit/2025/teaser/deco/red_02_179.png" width="179" alt="" /></li>
        <li class="js-deco deco_44"><img src="../assets/img/recruit/2025/teaser/deco/green_03_557.png" width="557" alt="" /></li>
      </ul>
    </div><!-- #recruit_2025_teaser_contents -->
  </div><!-- #recruit_2025_teaser -->

</div><!-- #contents -->
</template>

<script>
export default {
  name: 'recruit_2025',
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
    $('.js-click_box').click(function(){
      var link = $(this).find('a').attr('href');
      console.log(link);
      window.open(link);
      return false;
    });
    $('.js-click_box_no_window').click(function(){
      var link = $(this).find('a').attr('href');
      console.log(link);
      window.location.replace(link);
      return false;
    });
    $("body").css('background','#000');
    $(window).scroll(function () {
      if($(window).scrollTop() <= 0) {
        $("#video").removeClass("position_bottom").addClass("position_top");
      } else if($(window).scrollTop() + $(window).height() + 30 >= $("#recruit_2025_teaser").height()) {
        $("#video").removeClass("position_top").addClass("position_bottom");
      } else {
        $("#video").removeClass("position_top position_bottom");
        $(".js-shadow").addClass("shadow_add");
      }
      if($(window).scrollTop() <= 11){
        $(".js-shadow").removeClass("shadow_add");
      }
    });
    $(document).ready(function() {
      setTimeout(function () {
        window.scrollTo(0, 10)
        $(".kv_deco").css('animation-play-state','paused');
        setTimeout(function () {
          window.scrollTo(0, 0)
          $("#js-load").fadeOut(300);
        }, 300);
      }, 500);
      setTimeout(function () {
        $(".js-kv_ttl").addClass("active");
        setTimeout(function () {
          $(".js-kv_message").addClass("active");
        }, 500);
      }, 1800);
      var current_pattern_num = 1
      setInterval(function() {
        current_pattern_num++
        if(current_pattern_num == 2){
          $(".js-deco").addClass("pattern_02");
        } else if (current_pattern_num == 3) {
          $(".js-deco").addClass("pattern_03");
        } else if(current_pattern_num > 3) {
          $(".js-deco").removeClass("pattern_02 pattern_03");
          current_pattern_num = 1
        }
      }, 8000);
    });
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/recruit_2025_teaser.vue